import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type InfoFillProps = IconComponentBaseProps;

export const InfoFill = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.navy[7],
  className,
}: InfoFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_6405_1538"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_6405_1538)">
        <path
          d="M8 11.1667C8.14178 11.1667 8.2605 11.1187 8.35617 11.0228C8.45195 10.9271 8.49984 10.8083 8.49984 10.6667V7.83333C8.49984 7.69166 8.45189 7.57289 8.356 7.477C8.26011 7.38122 8.14134 7.33333 7.99967 7.33333C7.85789 7.33333 7.73917 7.38122 7.6435 7.477C7.54773 7.57289 7.49984 7.69166 7.49984 7.83333V10.6667C7.49984 10.8083 7.54778 10.9271 7.64367 11.0228C7.73956 11.1187 7.85834 11.1667 8 11.1667ZM7.99984 6.19233C8.15239 6.19233 8.28028 6.14072 8.3835 6.0375C8.48673 5.93428 8.53834 5.80639 8.53834 5.65383C8.53834 5.50127 8.48673 5.37339 8.3835 5.27016C8.28028 5.16705 8.15239 5.1155 7.99984 5.1155C7.84728 5.1155 7.71939 5.16705 7.61617 5.27016C7.51295 5.37339 7.46134 5.50127 7.46134 5.65383C7.46134 5.80639 7.51295 5.93428 7.61617 6.0375C7.71939 6.14072 7.84728 6.19233 7.99984 6.19233ZM8.001 14.3333C7.125 14.3333 6.30161 14.1671 5.53084 13.8347C4.76006 13.5022 4.08961 13.0511 3.5195 12.4812C2.94939 11.9113 2.498 11.2411 2.16534 10.4707C1.83278 9.70022 1.6665 8.87705 1.6665 8.00116C1.6665 7.12516 1.83273 6.30177 2.16517 5.531C2.49761 4.76022 2.94878 4.08977 3.51867 3.51966C4.08856 2.94955 4.75873 2.49816 5.52917 2.1655C6.29961 1.83294 7.12278 1.66666 7.99867 1.66666C8.87467 1.66666 9.69806 1.83289 10.4688 2.16533C11.2396 2.49777 11.9101 2.94894 12.4802 3.51883C13.0503 4.08872 13.5017 4.75889 13.8343 5.52933C14.1669 6.29978 14.3332 7.12294 14.3332 7.99883C14.3332 8.87483 14.1669 9.69822 13.8345 10.469C13.5021 11.2398 13.0509 11.9102 12.481 12.4803C11.9111 13.0504 11.2409 13.5018 10.4705 13.8345C9.70006 14.1671 8.87689 14.3333 8.001 14.3333Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
